<div id="content">
  <div class="page-title">
    <h1>{{ page_title }}</h1>

    <button mat-raised-button color="primary" (click)="openSelectTemplateDialog()">Crear a partir de plantilla</button>
  </div>

  <div class="bisual-table">
    <div class="bisual-table-container">
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="current_from">
          <th mat-header-cell *matHeaderCellDef>Desde</th>
          <td mat-cell *matCellDef="let record">
            <span
              [matTooltip]="record.is_active ? 'Plan actual' : record.is_future ? 'Plan futuro' : 'Plan pasado'"
              style="margin-right: 8px"
            >
              {{ record.is_active ? '🟢' : record.is_future ? '🔵' : '⚫' }}
            </span>

            <mat-form-field style="width: 140px">
              <input
                matInput
                [matDatepicker]="fromPicker"
                [(ngModel)]="record.current_from"
                [disabled]="record.is_past || (record.is_active && !record.is_future)"
                (dateChange)="updateDates(record)"
                [min]="record.minFrom"
                [max]="record.maxFrom"
              />

              <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
              <mat-datepicker #fromPicker></mat-datepicker>
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="current_until">
          <th mat-header-cell *matHeaderCellDef>Hasta</th>
          <td mat-cell *matCellDef="let record">
            <mat-form-field style="width: 140px">
              <input
                matInput
                [matDatepicker]="untilPicker"
                [(ngModel)]="record.current_until"
                [disabled]="record.is_past"
                (dateChange)="updateDates(record)"
                [min]="record.minUntil"
                [max]="record.maxUntil"
              />

              <mat-datepicker-toggle matSuffix [for]="untilPicker"></mat-datepicker-toggle>
              <mat-datepicker #untilPicker></mat-datepicker>
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="administrators_annotations">
          <th mat-header-cell *matHeaderCellDef>Anotaciones</th>
          <td mat-cell *matCellDef="let record">
            <mat-form-field style="min-width: 250px">
              <textarea matInput [(ngModel)]="record.administrators_annotations" (blur)="updateDates(record)" rows="2"></textarea>
            </mat-form-field>
          </td>
        </ng-container>

        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Acciones</th>
          <td mat-cell *matCellDef="let record">
            <button mat-icon-button [matMenuTriggerFor]="menu">
              <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="openCareerPlanYearsListDialog(record)">
                <mat-icon matPrefix>list</mat-icon>
                Ver años
              </button>

              <button
                mat-menu-item
                (click)="cloneCareerPlan(record.id)"
                [disabled]="record.is_past"
                [matTooltip]="record.is_past ? 'No se puede clonar un plan pasado' : 'Clonar'"
              >
                <mat-icon matPrefix>content_copy</mat-icon>
                Clonar
              </button>

              <button
                mat-menu-item
                (click)="deleteCareerPlan(record)"
                [disabled]="record.is_active || record.is_past"
                [matTooltip]="
                  record.is_active
                    ? 'No se puede eliminar un plan activo'
                    : record.is_past
                      ? 'No se puede eliminar un plan pasado'
                      : 'Eliminar plan'
                "
              >
                <mat-icon matPrefix color="warn">delete</mat-icon>
                Eliminar
              </button>
            </mat-menu>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>
</div>
